import { createAction } from '@reduxjs/toolkit';

export const htmlCodeUpdateId = createAction('htmlCode/updateId');
export const htmlCodeUpdateUID = createAction('htmlCode/updateUid');
export const htmlCodeUpdateSID = createAction('htmlCode/updateSid');
export const htmlCodeUpdateIsAdded = createAction('htmlCode/updateIsAdded');
export const htmlCodeUpdateIsActive = createAction('htmlCode/updateIsActive');

export const htmlCodeStore = createAction('htmlCode/store');
export const htmlCodeClear = createAction('htmlCode/clear');

export const htmlCodeUpdateRequest = createAction('htmlCode/updateRequest');
export const htmlCodeUpdateError = createAction('htmlCode/updateError');
export const htmlCodeUpdateStore = createAction('htmlCode/updateStore');

export const htmlCodeUpdateContent = createAction('htmlCode/updateContent');
